import  { useState } from "react";
import AllInfo from "./AllInfo";
import { AnimatePresence, motion } from "framer-motion";
import NoData from "./NoData";
import AllHeading from "./AllHeading";
import TaskCloumn from "./TaskCloumn";

const MileStoneCloumn = ({ milestones }) => {
  const [status, setStatus] = useState(false);
    const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.5, // delay between each child animation
      },
    },
  };

  return (
    <>
      <div className="milestonecolumn">
        <AllInfo
          all={milestones}
          status={status}
          setStatus={setStatus}
          componentName={"milestones"}
          style={{
            background:
              "linear-gradient(90deg,rgb(218, 227, 255),rgb(191, 204, 253))",
          }}
        />
      </div>
      <AnimatePresence>
        {status && (
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            <>
              {milestones?.tasks?.length > 0 ? (
                <>
                  <AllHeading>Task</AllHeading>
                  {milestones?.tasks?.map((taskval) => (
                    <TaskCloumn taskval={taskval} />
                  ))}
                </>
              ) : (
                <NoData>📌 No Task</NoData>
              )}
            </>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default MileStoneCloumn;
